//
//
//
//
//
//
export default {
  name: 'App'
};